module.exports = __webpack_public_path__ + "img/pl_Ecran 2.b2d98fb2.png";